"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonSchemaInferrer = void 0;
const helpers_1 = require("./helpers");
const JsonSchemaInferrer = (input, config) => {
    let source;
    const defaultConfig = {
        type: true,
        string: {
            detectFormat: false
        },
        object: {},
        array: {
            arrayInferMode: 'first'
        },
        common: {}
    };
    const inferConfig = !!config ? config : defaultConfig;
    // Format JSON, if invalid JSON, throw an error
    try {
        source = JSON.parse(JSON.stringify(input));
    }
    catch (e) {
        throw new Error(`Invalid JSON`);
    }
    /* root must have: $schema, which is draft version url. for now, default is draft-07,
  and url is http://json-schema.org/draft-07/schema */
    const root = (0, helpers_1.genSchema)(true, 'root', source, inferConfig);
    return root;
};
exports.JsonSchemaInferrer = JsonSchemaInferrer;
